import { useTranslation } from 'react-i18next';

import classNames from 'classnames';

import Typography from '~/components/Typography';

interface Props {
  text: string;
  fontFamily?: string;
  color?: string;
  className?: string;
}

const CopyrightText = ({ text, fontFamily, color, className }: Props) => {
  const year = new Date().getFullYear();
  const { t } = useTranslation();

  return (
    <Typography weight="light" className={classNames('!text-xs', className)} fontFamily={fontFamily} color={color}>
      {t('footer.copyright_simple', {
        year: year,
        name: text,
      })}
    </Typography>
  );
};

export default CopyrightText;
